<template>
  <div class="it-tab" data-test="ti-redesigned-tab">
    <section v-for="s in main" :key="s.id" class="it-block" :data-test="`ti-block-${s.id}`">
      <InsightSection v-if="s.ok" v-bind="sectionProps(s)" />
      <template v-else>
        <h5 class="it-h">{{ s.title }}</h5>
        <b-card class="background-cover"><EmptyState :restricted="!$can('view', s.subject)" :subject="s.subject" /></b-card>
      </template>
    </section>

    <section v-if="aging.length" class="it-block it-aging">
      <h5 class="it-h">Aging</h5>
      <b-tabs>
        <b-tab v-for="(s, i) in aging" :key="s.id" :title="s.tab" :active="i === 0" :data-test="`ti-block-${s.id}`">
          <div class="it-aging-body">
            <InsightSection v-if="s.ok" v-bind="sectionProps(s)" />
            <b-card v-else class="background-cover"><EmptyState :restricted="!$can('view', s.subject)" :subject="s.subject" /></b-card>
          </div>
        </b-tab>
      </b-tabs>
    </section>

    <section v-for="s in broken" :key="s.id" class="it-block" :data-test="`ti-block-${s.id}`">
      <InsightSection v-if="s.ok" v-bind="sectionProps(s)" />
      <template v-else>
        <h5 class="it-h">{{ s.title }}</h5>
        <b-card class="background-cover"><EmptyState :restricted="!$can('view', s.subject)" :subject="s.subject" /></b-card>
      </template>
    </section>
  </div>
</template>

<script>
import EmptyState from '@/components/EmptyState/EmptyState.vue';
import InsightSection from './InsightSection.vue';

/**
 * One tab of Team Insights (Today, Week-to-Date or Month-to-Date) in the redesigned charts (gate 'teamInsightsCharts', redesign/gate.js):
 * the six report sections in the classic order — Overdue Recall, Unscheduled Treatment, the Aging tabs (Outstanding Claims,
 * Pre-authorizations, Patient Balances) and Broken Appointment. It is handed the sections already built (sectionHelpers.js
 * tiPeriodSections) and only lays them out; a section with nothing to show gets the same EmptyState the classic page shows.
 */
export default {
  name: 'InsightsTab',
  components: { EmptyState, InsightSection },
  props: {
    // [{ id, group, tab, title, subject, ok, … InsightSection props }]
    sections: { type: Array, default: () => [] },
  },
  computed: {
    main() {
      return this.sections.filter(s => s.group === 'main');
    },
    aging() {
      return this.sections.filter(s => s.group === 'aging');
    },
    broken() {
      return this.sections.filter(s => s.group === 'broken');
    },
  },
  methods: {
    // Only the props InsightSection declares (the rest of a section object is for this layout).
    sectionProps(s) {
      const { title, subtitle, team, members, chips, stats, statsNote, timeRange, memberView, goal } = s;
      return { title, subtitle, team, members, chips, stats, statsNote, timeRange, memberView, goal };
    },
  },
};
</script>

<style lang="scss" scoped>
.it-tab {
  display: grid;
  gap: 28px;
  padding-top: 8px;
}

.it-h {
  margin: 0 0 10px;
  font-weight: 600;
}

.it-aging-body {
  padding-top: 16px;
}
</style>
